import basicTheme from '../basicTheme.js';

const inputStyleOverrides = {
    defaultProps: {
        disableUnderline: true,
        size: 'small',
        type: 'text',
    },
    styleOverrides: {
        root: {
            padding: basicTheme.spacing(1.5, 2),
            height: '30px',
            minWidth: '24px',
            transition: `color ${basicTheme.transitions.duration.fast} linear, border ${basicTheme.transitions.duration.fast} linear, background-color ${basicTheme.transitions.duration.fast} linear`,
            backgroundColor: basicTheme.palette.N70.main,
            color: basicTheme.palette.N10.main,
            borderRadius: '4px',
            cursor: 'pointer',
            '&:before': {
                borderRadius: '5px',
                backgroundColor: 'transparent',
                transition: `border ${basicTheme.transitions.duration.fast} linear`,
                border: `1px solid transparent`,
                content: "''",
                display: 'block',
                position: 'absolute',
                top: '-1px',
                left: '-1px',
                right: '-1px',
                bottom: '-1px',
                pointerEvents: 'none',
            },
            'input::placeholder': Object.assign({}, basicTheme.typography.body4),
            '&.MuiInputBase-inputMultiline': { lineHeight: '16px' },
            '&:hover': {
                backgroundColor: basicTheme.palette.N60.main,
                color: basicTheme.palette.primary.main,
                'input::placeholder': { color: basicTheme.palette.primary.dark },
            },
            '&.Mui-focused': {
                cursor: 'text',
                backgroundColor: basicTheme.palette.N70.main,
                color: basicTheme.palette.N10.main,
                ':before': {
                    borderColor: basicTheme.palette.primary.main,
                },
                ':hover': {
                    'input::placeholder': { color: basicTheme.palette.N30.main },
                },
                '&.Mui-error': {
                    'input::placeholder': { color: basicTheme.palette.primary.main },
                },
            },
            '&.Mui-error': {
                color: basicTheme.palette.error.main,
                '&:before': {
                    borderColor: basicTheme.palette.error.main,
                },
                'input::placeholder': { color: basicTheme.palette.error.main },
                ':hover': {
                    color: basicTheme.palette.error.main,
                    'input::placeholder': { color: basicTheme.palette.error.main },
                },
                '&.Mui-focused': {
                    'input::placeholder': { color: basicTheme.palette.N30.main },
                    ':hover': {
                        'input::placeholder': { color: basicTheme.palette.primary.dark },
                    },
                },
            },
            '&.Mui-error:hover': {
                backgroundColor: basicTheme.palette.N70.main,
                'input::placeholder': { color: basicTheme.palette.error.main },
            },
            '&.Mui-disabled:hover': {
                cursor: 'not-allowed',
            },
        },
        sizeSmall: { height: '20px', minWidth: '16px', padding: basicTheme.spacing(0.5, 1) },
        input: Object.assign(Object.assign({ transition: `color ${basicTheme.transitions.duration.fast} linear, background-color ${basicTheme.transitions.duration.fast} linear, border ${basicTheme.transitions.duration.fast} linear, fill ${basicTheme.transitions.duration.fast} linear` }, basicTheme.typography.body1), { lineHeight: '16px', padding: basicTheme.spacing(0), caretColor: basicTheme.palette.white.main, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', cursor: 'pointer', '&::placeholder': {
                color: basicTheme.palette.N30.main,
                fontStyle: 'italic',
                opacity: 1,
                letterSpacing: '0px',
            }, '&:hover': {
                '&::placeholder': { color: basicTheme.palette.primary.dark },
            }, '&:focus': {
                cursor: 'text',
                color: basicTheme.palette.N10.main,
                textOverflow: 'clip',
            }, '&::selection': {
                background: basicTheme.palette.primary.light,
                color: basicTheme.palette.N70.main,
            }, '&.Mui-disabled': {
                WebkitTextFillColor: basicTheme.palette.N30.main,
                color: basicTheme.palette.N30.main,
                cursor: 'not-allowed',
                '&::placeholder': {
                    color: basicTheme.palette.N30.main,
                },
            } }),
        multiline: {
            '.MuiInputBase-inputMultiline': {
                whiteSpace: 'pre-wrap',
                color: 'transparent',
                lineHeight: '16px',
            },
            '.MuiInputBase-inputMultiline:focus': { color: basicTheme.palette.N10.main },
            '.MuiInputBase-inputMultiline:disabled': { WebkitTextFillColor: 'transparent' },
            '.MuiInputBase-inputMultiline::placeholder': { color: 'transparent' },
        },
        fullWidth: {
            width: '100% !important',
        },
    },
    variants: [
        {
            props: { size: 'large' },
            style: {
                padding: basicTheme.spacing(0.75, 2),
                height: '36px',
                '.MuiInput-input': Object.assign(Object.assign({}, basicTheme.typography.h2), { lineHeight: '30px', '&::placeholder': {
                        fontSize: '20px',
                        letterSpacing: '0px',
                        fontFamily: basicTheme.typography.h2.fontFamily,
                    } }),
            },
        },
        {
            props: { size: 'medium', multiline: true },
            style: {
                padding: basicTheme.spacing(1.75, 2),
            },
        },
        {
            props: { type: 'date' },
            style: {
                'input::-webkit-clear-button,input::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    display: 'none',
                },
            },
        },
        {
            props: { type: 'time' },
            style: {
                'input::-webkit-clear-button,input::-webkit-inner-spin-button,input::-webkit-calendar-picker-indicator': {
                    WebkitAppearance: 'none',
                    display: 'none',
                    margin: basicTheme.spacing(0),
                },
            },
        },
    ],
};

export { inputStyleOverrides as default };
//# sourceMappingURL=MuiInput.js.map
